(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/maltipset/assets/javascripts/views/betslip/betslip-payoptions.js') >= 0) return;  svs.modules.push('/modules/maltipset/assets/javascripts/views/betslip/betslip-payoptions.js');

'use strict';

svs.maltipset.views.BetslipPayOptions = Marionette.View.extend({
  regions: {
    sportkryss: '.sportkryss',
    weeks: '.weeks'
  },
  events: {
    'click @ui.overviewButton': 'toggleOverviewBtn'
  },
  ui: {
    overviewButton: '.betslip-overview'
  },
  template(data) {
    return svs.maltipset.templates.betslip_payoptions(data);
  },
  toggleOverviewBtn(e) {
    if (!svs.core.detect.formfactor.mobile()) {
      const textSpan = $(e.currentTarget).find('span');
      textSpan.text(textSpan.text() === 'Visa översikt av spelet' ? 'Dölj översikt av spelet' : 'Visa översikt av spelet');
    }
  },
  hideShowHuxflux(value) {
    if (value === '0') {
      this.getRegion('sportkryss').currentView.ui.inputHolder.hide();
    } else {
      this.getRegion('sportkryss').currentView.ui.inputHolder.show();
    }
  },
  onRender() {
    const self = this;
    this.getRegion('sportkryss').show(new svs.sport.sportkryss.Sportkryss({
      model: this.options.coupon.get('hasSportkryssBet') ? this.options.coupon.get('sportkryssBet') : null,
      onSportkryssChanged(bet) {
        self.options.coupon.updateSportkryss(bet);
      },
      toggleButtonCSSClass: 'sportkryss-btn-maltipset',
      helpDialogTitle: svs.maltipset.data.config.helpTexts.sportkryss.title,
      helpDialogBody: svs.maltipset.data.config.helpTexts.sportkryss.body
    }));
    this.getRegion('weeks').show(new svs.maltipset.views.BetslipContentWeeks({
      model: new svs.maltipset.models.Betslip({
        coupon: this.options.coupon
      })
    }));
    setTimeout(() => {
      self.options.betslip.changeSize();
    }, 0);
  }
});

 })(window);